import React, { useContext } from 'react'
import { ReducerDispatchContext, ReducerContext } from '../reducers/reducerContext.js';
import { setFinanceFileProps, setVehicleExamples } from '../actions/actionsAppTest'
import FinanceFileSetting from '../components/setting/FinanceFileSetting'

export default function ContFinanceFileSetting() {

  const dispatch = useContext(ReducerDispatchContext);
  const globalstate = useContext(ReducerContext);

  function onChange(username, password, isFinanceFile) {
    dispatch(setFinanceFileProps(username, password, isFinanceFile));
    dispatch(
      setVehicleExamples(globalstate.testCriteria.context, globalstate.settings, globalstate, dispatch)
    )
  }

  return (
    <FinanceFileSetting
      settings={globalstate.settings}
      data={globalstate.env.financeFileProps}
      isAuthSimu={globalstate.env.isAuthSimu}
      isOpen={false}
      onChange={onChange}
    />
  );

}
